/** A held thing being carried to the plane: `{ ref, anchors }` as JSON. */
export const REF_MIME = 'application/x-pondering-ref';
/** Also set when the thing carried is a note, so Write can offer itself as a
 *  target while the drag is over it — a drop's data cannot be read until the
 *  drop, only its types. */
export const NOTE_MIME = 'application/x-pondering-note';
